<template>
  <div class="con">
    <van-sticky>
      <van-tabs v-model="headActive" color="#27bec4" @change="headBtn">
        <van-tab title="检验报告"></van-tab>
        <van-tab title="检查报告"></van-tab>
      </van-tabs>
      <van-cell-group style="margin-bottom: 10px;">
        <van-cell title="报告日期区间" :value="dateText" @click="show = true" />
        <van-calendar
          v-model="show"
          type="range"
          @confirm="onConfirm"
          color="#1989fa"
          max-range="183"
          :minDate="minDate"
          :maxDate="maxDate"
        />
      </van-cell-group>
    </van-sticky>

    <van-cell-group v-if="list && list.length > 0 && headActive===0">
      <van-cell
        center 
        v-for="(item, index) in list"
        :key="'d' + index"
        :title="item.EXAMINAIM"
        :value="formatDateTime(item.CHECKTIME)"
        
        is-link
        @click="toDetail(item)"
      />
    </van-cell-group>
    <van-cell-group v-if="list && list.length > 0 && headActive===1">
      <van-cell
        center 
        v-for="(item, index) in list"
        :key="'e' + index"
        :title="item.examineparts"
        :value="formatDateTime(item.reportdate)"
        :label="item.examinetype"
        is-link
        @click="toDetail(item)"
      />
    </van-cell-group>
    <div class="noImg" v-if="list.length == 0">
      <img src="../assets/404.gif" />
      <div class="no-text">无清单~~</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "report",
  data() {
    return {
      msg: "报告",
      list: [],
      cardUserInfo: JSON.parse(localStorage.getItem("cardUserInfo")),
      noImgShow: false,
      params: {},
      headActive: 0,
      date: [],
      dateText: [],
      show: false,
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(),
    };
  },
  methods: {
    headBtn(e) {
      this.headActive = e;
      this.loadData();
    },
    formatDate(date) {
      return `${date.getFullYear()}-${
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1
      }-${date.getDate()}`;
    },
    formatDateTime(date) {
      if(date){
        const date1 = new Date(date);
      return `${date1.getFullYear()}-${
        date1.getMonth() + 1 < 10
          ? "0" + (date1.getMonth() + 1)
          : date1.getMonth() + 1
      }-${date1.getDate()} ${date1.getHours()}:${date1.getMinutes()}`;
      }
      
    },
    onConfirm(date) {
      const [start, end] = date;
      this.show = false;
      this.dateText = `${this.formatDate(start)} 至 ${this.formatDate(end)}`;
    },
    loadData() {
      let url = "";
      const [start, end] = this.date;
      if (this.headActive == 0) {
        url =
          "/inpatient/queryLab?brid=" +
          this.params.brid +
          "&mzzy=" +
          this.params.type +
          "&startDate=" +
          this.formatDate(start) +
          "&endDate=" +
          this.formatDate(end);
      } else {
        url =
          "/inpatient/queryExam?brid=" +
          this.params.brid +
          "&mzzy=" +
          this.params.type +
          "&startDate=" +
          this.formatDate(start) +
          "&endDate=" +
          this.formatDate(end);
      }
      console.log(url);
      this.$store.commit("Load", true);
      this.$Axios
        .Get(url, null)
        .then((res) => {
          this.list = [];
          this.$store.commit("Load", false);
          if (res.code == 0) {
            this.list = res.msg;
            this.noImgShow = false;
          } else {
            this.noImgShow = true;
          }
        })
        .catch((err) => {
          this.$store.commit("Load", false);
          this.noImgShow = true;
          console.log(err);
        });
    },

    

    toDetail(e) {
      console.log(e);
      if(e){
        localStorage.setItem('report-headActive', this.headActive );
        let id = undefined
        if(this.headActive ===0){
          id= e.SAMPLENO
        }else{
          id = e.examid
        }
          this.$router.push({
          path: "/reportDeta",
          query: {
            brid: this.params.brid,
            mzzy: this.params.type,
            nav: this.headActive,
            id:id
          },
        });
      }
      



      // if (this.list[e].labId != "" && this.list[e].labId != undefined) {
      //   let data = {
      //     id: this.list[e].labId,
      //     nav: 0,
      //   };
      //   this.$router.push({
      //     path: "/reportDeta",
      //     query: {
      //       id: JSON.stringify(data),
      //     },
      //   });
      // } else if (
      //   this.list[e].reportId != "" &&
      //   this.list[e].reportId != undefined
      // ) {
      //   let data = {
      //     id: this.list[e].reportId,
      //     nav: 1,
      //   };
      //   this.$router.push({
      //     path: "/reportDeta",
      //     query: {
      //       id: JSON.stringify(data),
      //     },
      //   });
      // } else {
      //   this.$toast("结果还没出来");
      // }
    },
  },
  mounted() {
    this.params = this.$route.query;
    if (this.params.type == 1) {
      let start = new Date();
      start.setMonth(start.getMonth() - 6);
      this.date = [start, new Date()];
    } else {
      let start = new Date(this.params.startDate);
      let end = new Date(this.params.endDate);
      this.minDate = start;
      this.maxDate = end;
      this.date = [start, end];
    }
    console.log(localStorage.getItem('report-headActive'));

    this.headActive =  parseInt(localStorage.getItem('report-headActive')||0);

    this.onConfirm(this.date);
   
    this.loadData();
    
    
  },
  created() {

  },
};
</script>

<style scoped>
.head {
  overflow-y: auto;
}
.van-sticky {
  top: 10px; /*这里填入你需要吸顶到顶部的距离*/
}
.list {
  position: relative;
  padding: 5px 0;
  font-size: 14px;
  background: #fff;
  border-bottom: 1px solid #ccc;
}
.list-con {
  display: flex;
  margin: 10px 0;
}
.list-con label {
  color: #999;
  width: 80px;
  text-align: end;
}
.noImg {
  margin-top: 10vh;
  text-align: center;
}
.no-text {
  margin-top: 10px;
  color: #27bec4;
  font-size: 16px;
}
.queryBtn {
  position: absolute;
  right: 20px;
  top: 20px;
  text-align: center;
  color: #27bec4;
  font-size: 12px;
}
</style>
